import {
  GET_PRODUCTION_REPORT_REQUEST,
  GET_PRODUCTION_REPORT_SUCCESS,
  GET_PRODUCTION_REPORT_ERROR,
  GET_PRODUCTION_UNFINISHED_REPORT_REQUEST,
  GET_PRODUCTION_UNFINISHED_REPORT_SUCCESS,
  GET_PRODUCTION_UNFINISHED_REPORT_ERROR,
  GET_PRODUCTION_REASON_REPORT_REQUEST,
  GET_PRODUCTION_REASON_REPORT_SUCCESS,
  GET_PRODUCTION_REASON_REPORT_ERROR,
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";

export const productionReport = (token, data, isGenerate, isSKU) => (dispatch) => {
  dispatch({ type: GET_PRODUCTION_REPORT_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/Stylewiseproductionreport`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: {
      gender_id: isGenerate === undefined || isGenerate === "All" ? null : isGenerate,
      gender_category_id: null,
      sku: isSKU === undefined || isSKU === "All" ? null : isSKU,
      style_id: data.style_id === undefined || data.style_id === "All" ? null : data.style_id,
      product_status_id: null,
      season_id: data.current_season_id === undefined || data.current_season_id === "All" ? null : data.current_season_id,
      wash_id: data.wash_id === undefined || data.wash_id === "All" ? null : data.wash_id
    },
  })
    .then((response) => {
      return dispatch({
        type: GET_PRODUCTION_REPORT_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_PRODUCTION_REPORT_ERROR,
        payload: [],
      });
    });
};

export const getProductionUnFinished = (token, data,) => (dispatch) => {
  dispatch({ type: GET_PRODUCTION_UNFINISHED_REPORT_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/StylewiseproductionUnfinishedReport`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: {
      gender_id: data.gender_id === undefined || data.gender_id === "All" ? null : data.gender_id,
      gender_category_id: null,
      sku: data.sku === "All" ? null : data.sku,
      style_id: data.style_id === undefined || data.style_id === "All" ? null : data.style_id,
      product_status_id: null,
      season_id: data.current_season_id === undefined || data.current_season_id === "All" ? null : data.current_season_id,
      wash_id: data.wash_id === undefined || data.wash_id === "All" ? null : data.wash_id,
      stage: data.stage === undefined || data.stage === "All" ? null : data.stage,
      shipper: data.shipper === undefined || data.shipper === "All" ? null : data.shipper,
      reason_id: data.reason === undefined || data.reason === "All" ? null : data.reason,
      status: data.status === undefined || data.status === "All" ? null : data.status,
    },
  })
    .then((response) => {
      return dispatch({
        type: GET_PRODUCTION_UNFINISHED_REPORT_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_PRODUCTION_UNFINISHED_REPORT_ERROR,
        payload: [],
      });
    });
};

export const getProductionReason = (token) => (dispatch) => {
  dispatch({ type: GET_PRODUCTION_REASON_REPORT_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/ProductionReason`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
  })
    .then((response) => {
      return dispatch({
        type: GET_PRODUCTION_REASON_REPORT_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_PRODUCTION_REASON_REPORT_ERROR,
        payload: [],
      });
    });
};